'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeViewAvailabilityEvent = composeViewAvailabilityEvent;

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CATEGORIES = _constantsAnalytics2.default.CATEGORIES,
    EVENTS = _constantsAnalytics2.default.EVENTS,
    ACTIONS = _constantsAnalytics2.default.ACTIONS;


function composeAvailabilityEvent(_ref) {
  var eventName = _ref.eventName,
      gtmValue = _ref.gtmValue,
      gtmAction = _ref.gtmAction,
      gtmLabel = _ref.gtmLabel,
      reciprocalRank = _ref.reciprocalRank;

  return (0, _compose.composeEvent)(eventName, {
    gtmValue: gtmValue,
    gtmAction: gtmAction,
    gtmCategory: CATEGORIES.AVAILABILITY,
    gtmLabel: gtmLabel,
    reciprocalRank: reciprocalRank
  });
}

function composeViewAvailabilityEvent(_ref2) {
  var status = _ref2.status,
      reciprocalRank = _ref2.reciprocalRank;

  return (0, _compose.composeAnalytics)([composeAvailabilityEvent({
    eventName: EVENTS.CHECK_AVAILABILITY,
    gtmValue: 1,
    gtmAction: ACTIONS.VIEW,
    gtmLabel: status && status.toLowerCase(),
    reciprocalRank: reciprocalRank
  })]);
}

exports.default = {
  composeViewAvailabilityEvent: composeViewAvailabilityEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/availabilityEventComposer.js
// module id = 573
// module chunks = 0 2 4 5 6 8 9 10 11